import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { User } from 'firebase/auth';
import { cloudSync } from '../../services/sync/CloudSyncService';
import * as encryption from '../../services/security/encryption';

export const createTrialLicense = async (user: User, orgName: string): Promise<void> => {
    if (!user) throw new Error('User required to create license');

    const licenseRef = doc(db, 'licenses', user.uid);
    const existingLicense = await getDoc(licenseRef);

    if (existingLicense.exists()) {
        console.warn(`License already exists for user ${user.uid}, skipping trial creation.`);
        return;
    }

    // ВНИМАНИЕ: Набор полей должен СТРОГО соответствовать firestore.rules
    const now = new Date();
    const fourteenDaysLater = new Date();
    fourteenDaysLater.setDate(now.getDate() + 14);

    let finalOrgName = orgName || 'Моя организация';
    let finalDisplayName = user.displayName || '';

    // Encrypt PII if encryption is active
    if (cloudSync.hasActiveDEK) {
        try {
            const dek = await cloudSync.getEncryptionParams();
            if (dek?.key) {
                finalOrgName = await encryption.encrypt(finalOrgName, dek.key);
                finalDisplayName = await encryption.encrypt(finalDisplayName, dek.key);
                console.log("[licenseService] PII fields encrypted for new license.");
            }
        } catch (e) {
            console.error("Failed to encrypt license PII:", e);
        }
    }

    const licenseData = {
        status: 'trial',
        orgName: finalOrgName,
        displayName: finalDisplayName,
        photoURL: user.photoURL || '',
        email: user.email || '',
        vehicleLimit: 1,
        validFrom: now,
        validTo: fourteenDaysLater,
        createdAt: serverTimestamp()
    };

    await setDoc(licenseRef, licenseData);
};
